import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import React from "react";
import cn from "classnames";
import { css } from "@emotion/react";

export const FormIcon: ReactTFC<{
  iconAlignment: "top" | "center";
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
}> = props => {
  return (
    <props.Icon
      className={cn({
        top: props.iconAlignment === "top",
        center: props.iconAlignment === "center",
      })}
      css={css`
        width: 32px;
        margin: 0px 16px;

        &.top {
          align-self: flex-start;
          margin-top: 17px;
        }
      `}
    />
  );
};
